import { ReactNode } from 'react'
import { classNames } from '../../shared/utils/classnames'

export const Container = ({ children, className }: { children: ReactNode, className?: string }) => <div className={`container m-auto mb-8 md:mb-20 ${classNames(className)}`}>{children}</div>
